module.exports = __webpack_public_path__ + "static/media/icon-close-search-light.3dbd23a7.png";